import {
  MAINNET_PERP_METADATA_BY_PRODUCT_ID,
  TESTNET_PERP_METADATA_BY_PRODUCT_ID,
} from '../commonPerpMetadataByProductId';

export const BASE_PERP_METADATA_BY_PRODUCT_ID =
  MAINNET_PERP_METADATA_BY_PRODUCT_ID;

export const BASE_TESTNET_PERP_METADATA_BY_PRODUCT_ID =
  TESTNET_PERP_METADATA_BY_PRODUCT_ID;
